import React, { Component } from 'react';
import { THEMES } from '../../../../../configs/LayoutConfig';
import MaqueItem from './MaqueItem';
import {
  fetchIndicesData,
  subscribeRealtimeData,
  REDUCER_NAME,
  fetchTickerData,
  fetchHeadlineData,
} from './reducer';
import { connect } from 'react-redux';
import { compose } from 'redux';
import MessageHub from '../../../../../core/signalr/SignalrMessageHub';
import { ChanelConfig } from '../../../../../configs/GlobalConfig';
import RemoveHeadlinePopup from './RemoveHeadlinePopup';
import { isNotLogin } from '../../../../helpers/Common';
import NextImg from './next.svg';
import PauseImg from './pause.svg';
import PlayImg from './play.svg';
import PlayBlackImg from './play_black.svg';
import NextBlackImg from './next_black.svg';
import PauseBlackImg from './pause_black.svg';

const NEXT_INTERVAL = 10000;
const WIDTH_PER_ITEM = 222;

class NotifiMaque extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowPopup: false,
      autoNext: true,
      width: 0,
      page: 1,
    };
    this.contentRef = React.createRef();
  }

  componentDidMount() {
    const { user, fetchHeadlineData } = this.props;
    if (isNotLogin(user)) {
      fetchHeadlineData();
    }
    this.intervalNext();
    this.calcWidth();
    window.addEventListener('resize', this.calcWidth);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { page } = this.state;
    const { headlineCodes, fetchHeadlineData, headlineData } = this.props;

    //handle animation
    if (page !== prevState.page) {
      clearTimeout(this.flipTimeoutId);
      this.contentRef.current.classList.remove('flipInX');
      setTimeout(() => {
        this.contentRef.current.classList.add('flipInX');
        this.flipTimeoutId = setTimeout(() => {
          this.contentRef.current.classList.remove('flipInX');
        }, 1000);
      }, 0);
    }

    if (headlineCodes.length !== prevProps.headlineCodes.length) {
      fetchHeadlineData();
    }

    if (
      Object.keys(headlineData).length &&
      !Object.keys(prevProps.headlineData).length
    ) {
      const tickerCodes = headlineCodes.filter(item => item.isTicker);
      this.subscribeIndexChannel();
      if (tickerCodes.length) {
        this.subscribeTickChannel();
      }
    }

    if (
      headlineCodes.length &&
      prevProps.headlineCodes.length &&
      headlineCodes.length !== prevProps.headlineCodes
    ) {
      const tickerCodes = headlineCodes.filter(item => item.isTicker);
      MessageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
      if (tickerCodes.length) {
        this.subscribeTickChannel();
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
    MessageHub.unsubscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
    window.removeEventListener('resize', this.calcWidth);
    clearTimeout(this.flipTimeoutId);
  }

  calcWidth = () => {
    setTimeout(() => {
      const width = this.contentRef.current.getBoundingClientRect().width;
      this.setState({
        width,
      });
    }, 0);
  };

  intervalNext = () => {
    this.intervalId = setInterval(() => {
      const { autoNext } = this.state;
      if (!autoNext) {
        return;
      }
      this.nextPage();
    }, NEXT_INTERVAL);
  };

  getMaxPage = () => {
    const { width } = this.state;
    const { headlineCodes } = this.props;
    const perPage = Math.floor(width / WIDTH_PER_ITEM);

    return Math.ceil(headlineCodes.length / perPage);
  };

  nextPage = () => {
    const { page } = this.state;
    const newPage = page === this.getMaxPage() ? 1 : page + 1;
    this.setState({
      page: newPage,
    });
  };

  prevPage = () => {
    const { page } = this.state;
    const newPage = page === 1 ? this.getMaxPage() : page - 1;
    this.setState({
      page: newPage,
    });
  };

  subscribeIndexChannel = () => {
    MessageHub.subscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
  };

  subscribeTickChannel = () => {
    MessageHub.subscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
  };

  onReceiveTicker = tickers => {
    this.dispatchRealtime(tickers, 'organCode');
  };

  onReceiveIndex = data => {
    this.dispatchRealtime(data, 'comGroupCode');
  };

  dispatchRealtime = (data, key) => {
    const { headlineCodes, subscribeRealtimeData } = this.props;

    const dataRealtime = {};
    headlineCodes.forEach(({ code }) => {
      const realtimeObj = data.find(item => item[key] === code);
      if (realtimeObj) {
        dataRealtime[code] = realtimeObj;
      }
    });
    if (Object.keys(dataRealtime).length) {
      subscribeRealtimeData(dataRealtime);
    }
  };

  getItemPerPage = () => {
    const { headlineCodes } = this.props;
    const maxPage = this.getMaxPage();
    if (!maxPage) {
      return 0;
    }
    return Math.floor(headlineCodes.length / maxPage);
  };

  getCodes = () => {
    const { page } = this.state;
    const { headlineCodes } = this.props;
    const itemPerPage = this.getItemPerPage();

    return headlineCodes
      .concat()
      .splice((page - 1) * itemPerPage, page * itemPerPage);
  };

  renderContent = () => {
    const { headlineData } = this.props;
    if (!Object.keys(headlineData).length) {
      return null;
    }
    return this.getCodes().map(item => (
      <MaqueItem key={item.code} code={item.code} isTicker={item.isTicker} />
    ));
  };

  toggleShowPopup = () => {
    const { headlineCodes } = this.props;
    if (!headlineCodes.length) {
      this.setState({
        isShowPopup: false,
      });
      return;
    }
    this.setState(prevState => ({
      isShowPopup: !prevState.isShowPopup,
    }));
  };

  getNextImg = () => {
    const { theme } = this.props;
    return theme === THEMES.DARK ? NextImg : NextBlackImg;
  };

  getPlayPauseImg = () => {
    const { autoNext } = this.state;
    const { theme } = this.props;
    if (autoNext) {
      return theme === THEMES.DARK ? PauseImg : PauseBlackImg;
    }

    return theme === THEMES.DARK ? PlayImg : PlayBlackImg;
  };

  toggleAutoNext = () => {
    const { autoNext } = this.state;
    this.setState({
      autoNext: !autoNext,
    });
  };

  render() {
    const { isShowPopup } = this.state;

    return (
      <div className="notifi-maque-wrap w-100-150px float-left position-relative">
        <div className="notifi-maque">
          <div className="d-flex navigation">
            <div className="nav-button">
              <img
                onClick={this.prevPage}
                src={this.getNextImg()}
                className="prev"
                alt="next"
              />
            </div>
            <div className="nav-button">
              <img
                onClick={this.toggleAutoNext}
                src={this.getPlayPauseImg()}
                alt="pause"
              />
            </div>
            <div className="nav-button">
              <img onClick={this.nextPage} src={this.getNextImg()} alt="next" />
            </div>
          </div>

          <div ref={this.contentRef} className="content-maque">
            {this.renderContent()}
          </div>
          <div onClick={this.toggleShowPopup} className="open-remove-popup">
            <i className="icon-more" />
          </div>
        </div>
        {isShowPopup && (
          <RemoveHeadlinePopup toggleShow={this.toggleShowPopup} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  headlineCodes: state[REDUCER_NAME].headlineCodes,
  headlineData: state[REDUCER_NAME].headlineData,
  isHeadlineCodeLoading: state[REDUCER_NAME].isHeadlineCodeLoading,
  user: state.userInfo,
  theme: state.theme,
});

const mapDispatchToProps = {
  subscribeRealtimeData,
  fetchIndicesData,
  fetchTickerData,
  fetchHeadlineData,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(NotifiMaque);
